// Api
import AxiosClient from '@api/axiosClient';
// Urls
import { urls } from './urls';
import { IValidateChangeNoveltyContract } from '@models/Novelty';
import { TResult } from '@models/Result';

export const apiPostValidateChange = (data: IValidateChangeNoveltyContract): Promise<TResult> =>
    AxiosClient.post(urls.novelty.validate_change, data, false);
